export default __webpack_public_path__ + "static/media/expandComponetImg.c0163fcd.svg";